import * as React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@estee/elc-buttons';
import classnames from 'classnames';
import { classes } from '~utils/Classes';
import { SURVEY_BUTTONS_WRAPPER, SURVEY_BUTTON, SURVEY_BUTTONS_DATA } from '~constants/VtoSurvey';

interface IVtoSurveyButtons {
    surveyButtonIndex: number;
    setSurveyButtonIndex(index: number): void;
}

const vtoSurveyRatingButtonsWrapperClassNames = classes('vto-survey__rating-buttons-wrapper');

export const VtoSurveyButtons = observer(
    ({ surveyButtonIndex, setSurveyButtonIndex }: IVtoSurveyButtons) => {
        const handleSurveyButtonClick = (index: number) => {
            setSurveyButtonIndex(index);
        };

        return (
            <div
                className={vtoSurveyRatingButtonsWrapperClassNames}
                data-test-id={SURVEY_BUTTONS_WRAPPER}
            >
                {SURVEY_BUTTONS_DATA.map((buttonLabel: number, key: number) => {
                    const vtoSurveyRatingButton = classnames(
                        `${classes('vto-survey-overlay__rating-button')}`,
                        {
                            [classes('vto-survey-overlay__rating-button--selected')]:
                                surveyButtonIndex === key
                        }
                    );

                    return (
                        <Button
                            className={vtoSurveyRatingButton}
                            key={key}
                            onClick={() => handleSurveyButtonClick(key)}
                            data-test-id={SURVEY_BUTTON}
                        >
                            {buttonLabel}
                        </Button>
                    );
                })}
            </div>
        );
    }
);
